import React from 'react';
import { HeroBackgroundContainer } from './styles';

const HeroBackground = () => {
  return <HeroBackgroundContainer />;
};

export default HeroBackground;